var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
import { combineEpics } from "redux-observable";
import { loadResourcesUtils } from "@ane/core/lib/utils/LoadResourcesUtils";
import MdsDataplaneResources from "@ane/exp-data/lib/resources/MdsDataplaneResource";
import { WorkspaceMigrationTelemetryEventNames } from "@ane/exp-data/lib/telemetry/WorkspaceMigrationTelemetryEventNames";
import { defaultMSFTWorkspaceData } from "@ane/exp-data/lib/defaultData/defaultWorkspaceData";
import { isOnboardingPathname } from "@ane/exp-data/lib/routes/WorkspaceTenantSelectorRoute.utils";
import EnvironmentService from "@ane/core/lib/services/EnvironmentService";
import Logger from "@ane/core/lib/services/logging/Logger";
import { TelemetryEventName } from "@ane/core/lib/services/MSALAuthService/TelemetryEventName";
import { isIFrame } from "@ane/core/lib/host/Host.utilities";
import { AppTelemetryEventNames } from "@ane/exp-data/lib/telemetry/AppTelemetryEventNames";
import { isMsftWorkspaceById, isClassicWorkspaceById } from "@ane/exp-data/lib/utils/ManagementGroup";
import { navigateToOnboardingPage } from "./GetWorkspace.utils.js";
import { RestResult } from "@ane/core/lib/services/RestServiceBase";
import { MSFT_TENANT_ID } from "@ane/core/lib/services/MSALAuthService/MSAL.constants";
import WPSResource from "@ane/exp-data/lib/resources/WPSResource";
import { isUsingWPSWorkspaceAndProxyEnabled } from "@ane/core/lib/utils/WPSUtils";
const prefix = "ROOT_WORKSPACE";
const workspaceMigrationActionType = "WORKSPACE_MIGRATION";
const args = {
  actionPrefix: prefix,
  reduxKeyNested: () => ["workspace"],
  loadResource: (payload) => {
    return EnvironmentService.doNotLoadMSFTWorkspaceData() && isMsftWorkspaceById(payload.workspaceId) ? new Promise((resolve) => resolve(RestResult.fromResult(defaultMSFTWorkspaceData, true))) : EnvironmentService.getUser().tid === MSFT_TENANT_ID && !isClassicWorkspaceById(payload.workspaceId) ? WPSResource.getRootExperimentationGroup(payload.workspaceId) : MdsDataplaneResources.getRootExperimentationGroup(payload.workspaceId);
  },
  onCompleteSuccess: (result, inputPayload) => {
    var _a, _b;
    Logger.trackMetric({
      name: "WorkspaceInformationLoaded",
      average: 0,
      properties: result || {}
    });
    const needRequestToProxy = EnvironmentService.getUser().tid === MSFT_TENANT_ID && (result == null ? void 0 : result.TenantId) !== EnvironmentService.getUser().tid;
    const workspaceProxyEnabled = needRequestToProxy ? (result == null ? void 0 : result.WorkspaceProxyEnabled) || false : false;
    EnvironmentService.setWpsStatus({
      wpsWorkspaceId: inputPayload.workspaceId,
      needRequestToProxy,
      workspaceProxyEnabled
    });
    Logger.info(`${TelemetryEventName.WPS_Get_Workspace_Info}`, {
      needRequestToProxy: (_a = EnvironmentService.getWpsStatus()) == null ? void 0 : _a.needRequestToProxy,
      workspaceProxyEnabled: (_b = EnvironmentService.getWpsStatus()) == null ? void 0 : _b.workspaceProxyEnabled
    });
    if (!isOnboardingPathname() && !isIFrame()) {
      if (isUsingWPSWorkspaceAndProxyEnabled()) {
        Logger.info(`${TelemetryEventName.WPS_Will_Use_Proxy}`);
        return result;
      }
    }
    return result;
  },
  afterActionsOnFailure: (input, result) => {
    var _a;
    if (!result.errorContext || !!((_a = result == null ? void 0 : result.errorContext) == null ? void 0 : _a.statusCode) && (result.errorContext.statusCode >= 500 || result.errorContext.statusCode == 0)) {
      Logger.trackEvent({
        name: AppTelemetryEventNames.App_Init_GetRootWorkspace_Do_Not_Redirect_To_Onboarding,
        properties: __spreadValues({}, result),
        measurements: {}
      });
      return [{ type: "noop" }];
    }
    if (!isOnboardingPathname()) {
      Logger.trackEvent({
        name: AppTelemetryEventNames.App_Init_GetRootWorkspace_RedirectToOnboarding,
        properties: __spreadValues(__spreadValues({}, result), result == null ? void 0 : result.errorContext),
        measurements: {}
      });
      navigateToOnboardingPage();
    }
    return [{ type: "noop" }];
  }
};
const loadRootWorkspaceEpicReducer = loadResourcesUtils(args);
const workspaceMigrationArgs = {
  actionPrefix: workspaceMigrationActionType,
  reduxKeyNested: () => ["migration"],
  loadResource: () => {
    return MdsDataplaneResources.getWorkspaceMigrationStatus();
  },
  onCompleteSuccess: (result) => {
    Logger.trackEvent({
      name: WorkspaceMigrationTelemetryEventNames.WSMigration_GetWorkspaceMigrationStatus_loaded,
      properties: result || {},
      measurements: {}
    });
    return result;
  },
  afterActionsOnFailure: (input, result) => {
    Logger.trackEvent({
      name: WorkspaceMigrationTelemetryEventNames.WSMigration_GetWorkspaceMigrationStatus_failed,
      properties: __spreadValues({}, result),
      measurements: {}
    });
    return [{ type: "noop" }];
  }
};
const loadWorkspaceMigrationEpicReducer = loadResourcesUtils(workspaceMigrationArgs);
const managementGroupSelectorEpics = combineEpics(loadRootWorkspaceEpicReducer.epic, loadWorkspaceMigrationEpicReducer.epic);
export {
  managementGroupSelectorEpics as default,
  loadRootWorkspaceEpicReducer,
  loadWorkspaceMigrationEpicReducer
};
//# sourceMappingURL=GetWorkspace.epics.js.map
